import React from 'react';
import {css, StyleSheet} from 'aphrodite';

import {PRIVACY_POLICY_TEXT} from '../data/yabathoLegalContent';

const sections = PRIVACY_POLICY_TEXT.split('\n\n');

export default function PrivacyPolicy() {
  return (
    <main className={css(styles.page)}>
      <section className={css(styles.hero)}>
        <p className={css(styles.kicker)}>YaBatho Customer Web App</p>
        <h1 className={css(styles.title)}>Privacy Policy</h1>
        <p className={css(styles.subtitle)}>
          This page explains how YaBatho handles customer information, payments,
          delivery data, support requests, and account data.
        </p>
      </section>

      <section className={css(styles.content)}>
        {sections.map((section, index) => {
          const [firstLine, ...rest] = section.split('\n');
          const isTitle = index === 0;

          return (
            <article key={`${firstLine}-${index}`} className={css(styles.block)}>
              {isTitle ? (
                <h2 className={css(styles.policyTitle)}>{firstLine}</h2>
              ) : (
                <h3 className={css(styles.heading)}>{firstLine}</h3>
              )}

              {rest.map(line => (
                <p key={line} className={css(styles.text)}>
                  {line}
                </p>
              ))}
            </article>
          );
        })}
      </section>
    </main>
  );
}

const styles = StyleSheet.create({
  page: {
    minHeight: '100vh',
    backgroundColor: '#FBF7EF',
    color: '#073B2D',
    padding: '38px 18px 70px',
  },
  hero: {
    maxWidth: '920px',
    margin: '0 auto 24px',
    backgroundColor: '#0F3D2E',
    borderRadius: '28px',
    padding: '34px',
    color: '#fff',
  },
  kicker: {
    margin: 0,
    color: '#C9A14A',
    fontSize: '13px',
    fontWeight: 900,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },
  title: {
    margin: '10px 0',
    fontSize: 'clamp(34px, 5vw, 56px)',
    lineHeight: 1,
  },
  subtitle: {
    margin: 0,
    color: '#F5E9D2',
    fontSize: '18px',
    lineHeight: 1.6,
    maxWidth: '720px',
  },
  content: {
    maxWidth: '920px',
    margin: '0 auto',
    backgroundColor: '#fff',
    border: '1px solid #E8D8B8',
    borderRadius: '24px',
    padding: '30px',
    boxShadow: '0 18px 45px rgba(15, 61, 46, 0.08)',
  },
  block: {
    borderBottom: '1px solid #EFE2CA',
    padding: '18px 0',
    ':last-child': {
      borderBottom: 0,
    },
  },
  policyTitle: {
    margin: '0 0 8px',
    fontSize: '28px',
  },
  heading: {
    margin: '0 0 8px',
    fontSize: '20px',
    color: '#0F3D2E',
  },
  text: {
    margin: '7px 0',
    color: '#635747',
    fontSize: '16px',
    lineHeight: 1.6,
  },
});
